import LockIcon from '@mui/icons-material/Lock';
import EditIcon from '@mui/icons-material/Edit';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import FolderOffIcon from '@mui/icons-material/FolderOff';
import CloseIcon from '@mui/icons-material/Close';
import HistoryIcon from '@mui/icons-material/History';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import GroupsIcon from '@mui/icons-material/Groups';
import BackHandIcon from '@mui/icons-material/BackHand';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import BadgeIcon from '@mui/icons-material/Badge';
import HouseIcon from '@mui/icons-material/House';
import TollIcon from '@mui/icons-material/Toll';
import EventRepeatIcon from '@mui/icons-material/EventRepeat';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import CreditCardOffIcon from '@mui/icons-material/CreditCardOff';
import GavelIcon from '@mui/icons-material/Gavel';
import HistoryEduIcon from '@mui/icons-material/HistoryEdu';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import ChatIcon from '@mui/icons-material/Chat';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import PaidIcon from '@mui/icons-material/Paid';
import StorefrontIcon from '@mui/icons-material/Storefront';
import ShowerIcon from '@mui/icons-material/Shower';
import PhonelinkEraseIcon from '@mui/icons-material/PhonelinkErase';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import FlashOnIcon from '@mui/icons-material/FlashOn';
import PersonOffIcon from '@mui/icons-material/PersonOff';
import ChurchIcon from '@mui/icons-material/Church';
import ClearIcon from '@mui/icons-material/Clear';
import ContentPasteOffIcon from '@mui/icons-material/ContentPasteOff';
import FlagIcon from '@mui/icons-material/Flag';
import ColorizeIcon from '@mui/icons-material/Colorize';
import AttributionIcon from '@mui/icons-material/Attribution';
import AssuredWorkloadIcon from '@mui/icons-material/AssuredWorkload';
import ChildFriendlyIcon from '@mui/icons-material/ChildFriendly';
import LiveHelpIcon from '@mui/icons-material/LiveHelp';
import Brightness5Icon from '@mui/icons-material/Brightness5';
import FamilyRestroomIcon from '@mui/icons-material/FamilyRestroom';
import SportsMmaIcon from '@mui/icons-material/SportsMma';
import FlashOffIcon from '@mui/icons-material/FlashOff';
import AnnouncementIcon from '@mui/icons-material/Announcement';
import HealingIcon from '@mui/icons-material/Healing';
import WhatshotIcon from '@mui/icons-material/Whatshot';
import FireplaceIcon from '@mui/icons-material/Fireplace';
import LocalPoliceIcon from '@mui/icons-material/LocalPolice';
import HardwareIcon from '@mui/icons-material/Hardware';
import NewspaperIcon from '@mui/icons-material/Newspaper';
import PhoneInTalkIcon from '@mui/icons-material/PhoneInTalk';
import UpcomingIcon from '@mui/icons-material/Upcoming';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import LanguageIcon from '@mui/icons-material/Language';
import NoAccountsIcon from '@mui/icons-material/NoAccounts';
import OnlinePredictionIcon from '@mui/icons-material/OnlinePrediction';
import CasinoIcon from '@mui/icons-material/Casino';
import VaccinesIcon from '@mui/icons-material/Vaccines';
import SmokingRoomsIcon from '@mui/icons-material/SmokingRooms';
import EuroIcon from '@mui/icons-material/Euro';
import RestaurantMenuIcon from '@mui/icons-material/RestaurantMenu';
import EmojiNatureIcon from '@mui/icons-material/EmojiNature';
import ForestIcon from '@mui/icons-material/Forest';
import PersonalInjuryIcon from '@mui/icons-material/HeartBroken';
import PeopleIcon from '@mui/icons-material/People';
import ForumIcon from '@mui/icons-material/Forum';
import HandshakeIcon from '@mui/icons-material/Handshake';
import WorkIcon from '@mui/icons-material/Work';
import DomainDisabledIcon from '@mui/icons-material/DomainDisabled';
import BusinessIcon from '@mui/icons-material/Business';
import MoneyIcon from '@mui/icons-material/Money';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import MoneyOffIcon from '@mui/icons-material/MoneyOff';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import FoodBankIcon from '@mui/icons-material/FoodBank';
import SavingsIcon from '@mui/icons-material/Savings';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import BalanceIcon from '@mui/icons-material/Balance';
import CommuteIcon from '@mui/icons-material/Commute';
import SportsBarIcon from '@mui/icons-material/SportsBar';
import PlagiarismIcon from '@mui/icons-material/Plagiarism';
import GarageIcon from '@mui/icons-material/Garage';
import FlightIcon from '@mui/icons-material/Flight';
import AirplanemodeInactiveIcon from '@mui/icons-material/AirplanemodeInactive';
import LiquorIcon from '@mui/icons-material/Liquor';
import MinorCrashIcon from '@mui/icons-material/MinorCrash';
import FolderSpecialIcon from '@mui/icons-material/FolderSpecial';
import DriveEtaIcon from '@mui/icons-material/DriveEta';
import CarCrashIcon from '@mui/icons-material/CarCrash';
import VideocamIcon from '@mui/icons-material/Videocam';
import LocalActivityIcon from '@mui/icons-material/LocalActivity';
import NewReleasesIcon from '@mui/icons-material/NewReleases';
import LoupeIcon from '@mui/icons-material/Loupe';

// Données des indices - exportées comme constante pour éviter la recréation à chaque rendu
export const indicesData = [
  {
    "code": "01",
    "name": "Infraction inexistante",
    "icon": "QuestionMark",
    "color": "#757575"
  },
  {
    "code": "02",
    "name": "Infraction inexistante",
    "icon": "QuestionMark",
    "color": "#757575"
  },
  {
    "code": "03",
    "name": "Infraction inexistante",
    "icon": "QuestionMark",
    "color": "#757575"
  },
  {
    "code": "04",
    "name": "Infraction inexistante",
    "icon": "QuestionMark",
    "color": "#757575"
  },
  {
    "code": "05",
    "name": "Infraction inexistante",
    "icon": "QuestionMark",
    "color": "#757575"
  },
  {
    "code": "06",
    "name": "Infraction inexistante",
    "icon": "QuestionMark",
    "color": "#757575"
  },
  {
    "code": "07",
    "name": "Infraction inexistante",
    "icon": "QuestionMark",
    "color": "#757575"
  },
  {
    "code": "08",
    "name": "Infraction inexistante",
    "icon": "QuestionMark",
    "color": "#757575"
  },
  {
    "code": "09",
    "name": "Infraction inexistante",
    "icon": "QuestionMark",
    "color": "#757575"
  },
  {
    "code": "10",
    "name": "Association de malfaiteurs et prise d'otage",
    "icon": "Groups",
    "color": "#9c27b0"
  },
  {
    "code": "11",
    "name": "Vol avec violence",
    "icon": "BackHand",
    "color": "#827717"
  },
  {
    "code": "12",
    "name": "Vol à l'étalage",
    "icon": "ShoppingCart",
    "color": "#00838f"
  },
  {
    "code": "13",
    "name": "Infraction de carte d'identité",
    "icon": "Badge",
    "color": "#d32f2f"
  },
  {
    "code": "14",
    "name": "Vol domestique",
    "icon": "House",
    "color": "#388e3c"
  },
  {
    "code": "15",
    "name": "Fausse monnaie",
    "icon": "Toll",
    "color": "#1976d2"
  },
  {
    "code": "16",
    "name": "Evasion de détenu et Schengen",
    "icon": "EventRepeat",
    "color": "#e65100"
  },
  {
    "code": "17",
    "name": "Vol qualifié",
    "icon": "LockOutline",
    "color": "#689f38"
  },
  {
    "code": "18",
    "name": "Vol simple",
    "icon": "LockOpen",
    "color": "#0277bd"
  },
  {
    "code": "19",
    "name": "Virement sans provision",
    "icon": "CreditCardOff",
    "color": "#c2185b"
  },
  {
    "code": "20",
    "name": "Fraudes et escroqueries",
    "icon": "Gavel",
    "color": "#9e9d24"
  },
  {
    "code": "21",
    "name": "Fausse déclaration",
    "icon": "HistoryEdu",
    "color": "#0097a7"
  },
  {
    "code": "22",
    "name": "Faux nom",
    "icon": "DriveFileRenameOutline",
    "color": "#d84315"
  },
  {
    "code": "23",
    "name": "Faux témoignage",
    "icon": "Chat",
    "color": "#558b2f"
  },
  {
    "code": "24",
    "name": "Contrefaçon",
    "icon": "ShoppingBag",
    "color": "#1565c0"
  },
  {
    "code": "25",
    "name": "Corruption",
    "icon": "Paid",
    "color": "#ad1457"
  },
  {
    "code": "26",
    "name": "Grivèlerie",
    "icon": "Storefront",
    "color": "#afb42b"
  },
  {
    "code": "27",
    "name": "Recel et blanchiment",
    "icon": "Shower",
    "color": "#00acc1"
  },
  {
    "code": "28",
    "name": "Objets perdus",
    "icon": "PhonelinkErase",
    "color": "#bf360c"
  },
  {
    "code": "29",
    "name": "Mendicité",
    "icon": "CurrencyExchange",
    "color": "#33691e"
  },
  {
    "code": "30",
    "name": "Meurtre",
    "icon": "FlashOn",
    "color": "#0d47a1"
  },
  {
    "code": "31",
    "name": "Suicide",
    "icon": "PersonOff",
    "color": "#880e4f"
  },
  {
    "code": "32",
    "name": "Collocation et décès",
    "icon": "Church",
    "color": "#827717"
  },
  {
    "code": "33",
    "name": "Privation arbitraire de la liberté",
    "icon": "Clear",
    "color": "#006064"
  },
  {
    "code": "34",
    "name": "Actes arbitraires commis par l'autorité",
    "icon": "ContentPasteOff",
    "color": "#e64a19"
  },
  {
    "code": "35",
    "name": "Terrorisme",
    "icon": "Flag",
    "color": "#558b2f"
  },
  {
    "code": "36",
    "name": "Armes",
    "icon": "Colorize",
    "color": "#0288d1"
  },
  {
    "code": "37",
    "name": "Moeurs",
    "icon": "Attribution",
    "color": "#ad1457"
  },
  {
    "code": "38",
    "name": "Infractions liées aux obligations institutionnelles",
    "icon": "AssuredWorkload",
    "color": "#9e9d24"
  },
  {
    "code": "39",
    "name": "Avortement",
    "icon": "ChildFriendly",
    "color": "#0097a7"
  },
  {
    "code": "40",
    "name": "Enlèvement et disparition",
    "icon": "LiveHelp",
    "color": "#f4511e"
  },
  {
    "code": "41",
    "name": "Outrage et rébellion",
    "icon": "Brightness5",
    "color": "#7cb342"
  },
  {
    "code": "42",
    "name": "Infractions familiales et protection de mineurs",
    "icon": "FamilyRestroom",
    "color": "#303f9f"
  },
  {
    "code": "43",
    "name": "Coups et blessures volontaires",
    "icon": "SportsMma",
    "color": "#c2185b"
  },
  {
    "code": "44",
    "name": "Homicide involontaire",
    "icon": "FlashOff",
    "color": "#9e9d24"
  },
  {
    "code": "45",
    "name": "Menaces",
    "icon": "Announcement",
    "color": "#0288d1"
  },
  {
    "code": "46",
    "name": "Coups et blessures involontaires",
    "icon": "Healing",
    "color": "#ef6c00"
  },
  {
    "code": "47",
    "name": "Incendie volontaire",
    "icon": "Whatshot",
    "color": "#8bc34a"
  },
  {
    "code": "48",
    "name": "Incendie et dommage involontaire",
    "icon": "Fireplace",
    "color": "#0277bd"
  },
  {
    "code": "49",
    "name": "Immixtion dans les fonctions publiques",
    "icon": "LocalPolice",
    "color": "#d81b60"
  },
  {
    "code": "50",
    "name": "Dégradation et destruction",
    "icon": "Hardware",
    "color": "#689f38"
  },
  {
    "code": "51",
    "name": "Délit de presse",
    "icon": "Newspaper",
    "color": "#0288d1"
  },
  {
    "code": "52",
    "name": "Diffamation et secret professionnel",
    "icon": "PhoneInTalk",
    "color": "#8e24aa"
  },
  {
    "code": "53",
    "name": "Harcèlement et violation de domicile",
    "icon": "Upcoming",
    "color": "#f9a825"
  },
  {
    "code": "54",
    "name": "Manifestation",
    "icon": "PriorityHigh",
    "color": "#00838f"
  },
  {
    "code": "55",
    "name": "Loi sur les étrangers",
    "icon": "Language",
    "color": "#e64a19"
  },
  {
    "code": "56",
    "name": "Discrimination",
    "icon": "NoAccounts",
    "color": "#7cb342"
  },
  {
    "code": "57",
    "name": "Sectes",
    "icon": "OnlinePrediction",
    "color": "#1565c0"
  },
  {
    "code": "58",
    "name": "Jeux de hasard",
    "icon": "Casino",
    "color": "#aa00ff"
  },
  {
    "code": "59",
    "name": "Infractions médicales",
    "icon": "Vaccines",
    "color": "#9e9d24"
  },
  {
    "code": "60",
    "name": "Stupéfiants",
    "icon": "SmokingRooms",
    "color": "#00acc1"
  },
  {
    "code": "61",
    "name": "Infractions économiques",
    "icon": "Euro",
    "color": "#ef6c00"
  },
  {
    "code": "62",
    "name": "Infractions alimentaires",
    "icon": "RestaurantMenu",
    "color": "#7cb342"
  },
  {
    "code": "63",
    "name": "Protection de la faune et de la flore",
    "icon": "EmojiNature",
    "color": "#0d47a1"
  },
  {
    "code": "64",
    "name": "Infractions à l'environnement",
    "icon": "Forest",
    "color": "#880e4f"
  },
  {
    "code": "65",
    "name": "Accident de travail",
    "icon": "PersonalInjury",
    "color": "#9e9d24"
  },
  {
    "code": "66",
    "name": "Infractions envers le public",
    "icon": "People",
    "color": "#0097a7"
  },
  {
    "code": "67",
    "name": "Communications, aviation et navigation",
    "icon": "Forum",
    "color": "#e64a19"
  },
  {
    "code": "68",
    "name": "Tromperie",
    "icon": "Handshake",
    "color": "#8bc34a"
  },
  {
    "code": "69",
    "name": "Infraction au travail",
    "icon": "Work",
    "color": "#1565c0"
  },
  {
    "code": "70",
    "name": "Infractions liées aux patrons des sociétés",
    "icon": "DomainDisabled",
    "color": "#ad1457"
  },
  {
    "code": "71",
    "name": "Infractions liées aux sociétés",
    "icon": "Business",
    "color": "#9e9d24"
  },
  {
    "code": "72",
    "name": "Insolvabilité frauduleuse",
    "icon": "CreditCardOff",
    "color": "#00acc1"
  },
  {
    "code": "73",
    "name": "Infractions monétaires",
    "icon": "Money",
    "color": "#ef6c00"
  },
  {
    "code": "74",
    "name": "Infractions liées à la bourse",
    "icon": "ShowChart",
    "color": "#7cb342"
  },
  {
    "code": "75",
    "name": "Faillite",
    "icon": "MoneyOff",
    "color": "#0d47a1"
  },
  {
    "code": "76",
    "name": "Infractions des banques",
    "icon": "AccountBalance",
    "color": "#aa00ff"
  },
  {
    "code": "77",
    "name": "Infraction par une ASBL",
    "icon": "FoodBank",
    "color": "#9e9d24"
  },
  {
    "code": "78",
    "name": "Fraude fiscale",
    "icon": "Savings",
    "color": "#00acc1"
  },
  {
    "code": "79",
    "name": "Douanes et accises",
    "icon": "ImportExport",
    "color": "#e65100"
  },
  {
    "code": "80",
    "name": "Appels contre les jugements des tribunaux de Police",
    "icon": "Balance",
    "color": "#7cb342"
  },
  {
    "code": "81",
    "name": "Accident de roulage avec blessés",
    "icon": "Commute",
    "color": "#0288d1"
  },
  {
    "code": "82",
    "name": "Infraction inexistante",
    "icon": "QuestionMark",
    "color": "#757575"
  },
  {
    "code": "83",
    "name": "Infraction inexistante",
    "icon": "QuestionMark",
    "color": "#757575"
  },
  {
    "code": "84",
    "name": "Infraction inexistante",
    "icon": "QuestionMark",
    "color": "#757575"
  },
  {
    "code": "85",
    "name": "Accident de roulage avec blessés et ivresse ou alcool",
    "icon": "SportsBar",
    "color": "#ef6c00"
  },
  {
    "code": "86",
    "name": "Non assurance",
    "icon": "Plagiarism",
    "color": "#689f38"
  },
  {
    "code": "87",
    "name": "Accident de roulage mortel",
    "icon": "Garage",
    "color": "#1565c0"
  },
  {
    "code": "88",
    "name": "Infractions fluviales, aériennes et maritimes",
    "icon": "Flight",
    "color": "#c2185b"
  },
  {
    "code": "89",
    "name": "Accident fluvial, aérien et maritime",
    "icon": "AirplanemodeInactive",
    "color": "#afb42b"
  },
  {
    "code": "90",
    "name": "Ivresse au volant",
    "icon": "Liquor",
    "color": "#00acc1"
  },
  {
    "code": "91",
    "name": "Accident dégat matériel",
    "icon": "MinorCrash",
    "color": "#ef6c00"
  },
  {
    "code": "92",
    "name": "Lois spéciales",
    "icon": "FolderSpecial",
    "color": "#7cb342"
  },
  {
    "code": "93",
    "name": "Roulage",
    "icon": "DriveEta",
    "color": "#0d47a1"
  },
  {
    "code": "94",
    "name": "Code de la route",
    "icon": "CarCrash",
    "color": "#880e4f"
  },
  {
    "code": "95",
    "name": "Caméras automatiques",
    "icon": "Videocam",
    "color": "#9e9d24"
  },
  {
    "code": "96",
    "name": "Infraction inexistante",
    "icon": "QuestionMark",
    "color": "#757575"
  },
  {
    "code": "97",
    "name": "Infraction inexistante",
    "icon": "QuestionMark",
    "color": "#757575"
  },
  {
    "code": "98",
    "name": "Perceptions immédiates",
    "icon": "LocalActivity",
    "color": "#7cb342"
  },
  {
    "code": "99",
    "name": "Avertissements",
    "icon": "NewReleases",
    "color": "#0288d1"
  },
  {
    "code": "__",
    "name": "Procès-verbal subséquent",
    "icon": "Loupe",
    "color": "#2196f3"
  }
];

// Map des icônes - créé une seule fois pour optimiser les performances
const iconMap = {
  'QuestionMark': QuestionMarkIcon,
  'Groups': GroupsIcon,
  'BackHand': BackHandIcon,
  'ShoppingCart': ShoppingCartIcon,
  'Badge': BadgeIcon,
  'House': HouseIcon,
  'Toll': TollIcon,
  'EventRepeat': EventRepeatIcon,
  'LockOutline': LockOutlinedIcon,
  'LockOpen': LockOpenIcon,
  'CreditCardOff': CreditCardOffIcon,
  'Gavel': GavelIcon,
  'HistoryEdu': HistoryEduIcon,
  'DriveFileRenameOutline': DriveFileRenameOutlineIcon,
  'Chat': ChatIcon,
  'ShoppingBag': ShoppingBagIcon,
  'Paid': PaidIcon,
  'Storefront': StorefrontIcon,
  'Shower': ShowerIcon,
  'PhonelinkErase': PhonelinkEraseIcon,
  'CurrencyExchange': CurrencyExchangeIcon,
  'FlashOn': FlashOnIcon,
  'PersonOff': PersonOffIcon,
  'Church': ChurchIcon,
  'Clear': ClearIcon,
  'ContentPasteOff': ContentPasteOffIcon,
  'Flag': FlagIcon,
  'Colorize': ColorizeIcon,
  'Attribution': AttributionIcon,
  'AssuredWorkload': AssuredWorkloadIcon,
  'ChildFriendly': ChildFriendlyIcon,
  'LiveHelp': LiveHelpIcon,
  'Brightness5': Brightness5Icon,
  'FamilyRestroom': FamilyRestroomIcon,
  'SportsMma': SportsMmaIcon,
  'FlashOff': FlashOffIcon,
  'Announcement': AnnouncementIcon,
  'Healing': HealingIcon,
  'Whatshot': WhatshotIcon,
  'Fireplace': FireplaceIcon,
  'LocalPolice': LocalPoliceIcon,
  'Hardware': HardwareIcon,
  'Newspaper': NewspaperIcon,
  'PhoneInTalk': PhoneInTalkIcon,
  'Upcoming': UpcomingIcon,
  'PriorityHigh': PriorityHighIcon,
  'Language': LanguageIcon,
  'NoAccounts': NoAccountsIcon,
  'OnlinePrediction': OnlinePredictionIcon,
  'Casino': CasinoIcon,
  'Vaccines': VaccinesIcon,
  'SmokingRooms': SmokingRoomsIcon,
  'Euro': EuroIcon,
  'RestaurantMenu': RestaurantMenuIcon,
  'EmojiNature': EmojiNatureIcon,
  'Forest': ForestIcon,
  'PersonalInjury': PersonalInjuryIcon,
  'People': PeopleIcon,
  'Forum': ForumIcon,
  'Handshake': HandshakeIcon,
  'Work': WorkIcon,
  'DomainDisabled': DomainDisabledIcon,
  'Business': BusinessIcon,
  'Money': MoneyIcon,
  'ShowChart': ShowChartIcon,
  'MoneyOff': MoneyOffIcon,
  'AccountBalance': AccountBalanceIcon,
  'FoodBank': FoodBankIcon,
  'Savings': SavingsIcon,
  'ImportExport': ImportExportIcon,
  'Balance': BalanceIcon,
  'Commute': CommuteIcon,
  'SportsBar': SportsBarIcon,
  'Plagiarism': PlagiarismIcon,
  'Garage': GarageIcon,
  'Flight': FlightIcon,
  'AirplanemodeInactive': AirplanemodeInactiveIcon,
  'Liquor': LiquorIcon,
  'MinorCrash': MinorCrashIcon,
  'FolderSpecial': FolderSpecialIcon,
  'DriveEta': DriveEtaIcon,
  'CarCrash': CarCrashIcon,
  'Videocam': VideocamIcon,
  'LocalActivity': LocalActivityIcon,
  'NewReleases': NewReleasesIcon,
  'Loupe': LoupeIcon,
};

// Cache pour les données d'indice pour éviter les recherches répétées
const indiceCache = new Map();

/**
 * Fonction pour récupérer les données d'indice selon le code
 * Utilise un cache pour optimiser les performances
 * @param {string} indiceCode - Le code de l'indice
 * @returns {Object} Les données de l'indice
 */
export const getIndiceData = (indiceCode) => {
  // Vérifier le cache d'abord
  if (indiceCache.has(indiceCode)) {
    return indiceCache.get(indiceCode);
  }

  // Rechercher dans les données
  const indice = indicesData.find(item => item.code === indiceCode) || 
                 indicesData.find(item => item.code === "__");
  
  // Mettre en cache le résultat
  indiceCache.set(indiceCode, indice);
  
  return indice;
};

/**
 * Fonction pour récupérer l'icône MUI selon le nom d'icône
 * @param {string} iconName - Le nom de l'icône
 * @returns {React.Component} Le composant d'icône MUI
 */
export const getIconComponent = (iconName) => {
  return iconMap[iconName] || QuestionMarkIcon;
};

/**
 * Hook personnalisé pour utiliser les données d'indices de manière optimisée
 * @returns {Object} Objet contenant les fonctions et données utiles
 */
export const useIndiceInfos = () => {
  return {
    indicesData,
    getIndiceData,
    getIconComponent,
    // Fonction utilitaire pour obtenir toutes les informations d'un indice en une fois
    getCompleteIndiceInfo: (indiceCode) => {
      const data = getIndiceData(indiceCode);
      return {
        ...data,
        IconComponent: getIconComponent(data.icon)
      };
    }
  };
};

// Export par défaut pour la compatibilité
export default {
  indicesData,
  getIndiceData,
  getIconComponent,
  useIndiceInfos
};
